import React, { Component } from 'react'
import * as actions from "./actions";
import * as utils from "../utils";
import * as common_utils from "../../common/utils";

import FetchingContent from "../common/components/fetching-content";
import TimeSince from "../common/components/time-since";
import UserAvatar from "../avatars/components";
import UserProfileLink from "../common/components/user-profile-link";
import { connect } from 'react-redux';
import { findDOMNode } from 'react-dom';

const GuestList = React.createClass({
  componentWillMount: function() {
    if (this.props.state.guestlist.fetchingGuestlist) {
      actions.fetchGuestlistData();
    }
  },
  render: function() {
    const guestlistData = this.props.state.guestlist.guestlistData;
    const searchText =this.props.state.guestlist.searchText;
    const allowInviteMore = window.evite_event.options.event_option_allow_invite_more;
    const hasPassed = utils.eventHasPassed();
    const isCanceled = window.evite_event.status === "cancelled";
    const isMobile = utils.isMobile();
    const private_guest_list = window.evite_event.options.event_option_private_guestlist;
    const showInviteMore = (allowInviteMore || utils.isHost()) && utils.hasRsvpd() && !hasPassed && !isCanceled && !window.is_premium;

    if (private_guest_list && !utils.isHost()) {
      return <PrivateGuestList showInviteMore={showInviteMore} />;
    }

    if (this.props.state.guestlist.fetchingGuestlist) {
      return <FetchingContent fetching="guests" />;
    }

    return (
      <div className="event-guestlist simple-shadowbox">
        <div className="titleblock">
          <h3>{guestlistData.rsvp_style && guestlistData.rsvp_style.who || "Who's Coming?"}</h3>
          <div className="extra-content">
            <SearchBar searchText={searchText} />
            { showInviteMore &&
              <InviteMore
                inviteMoreUrl={window.invite_more_url}
                eventTitle={window.evite_event.title}
                eventShortlink={window.evite_event.shortlink}
                facebookSendUrl={window.facebook_send_url}
              />
            }
          </div>
        </div>
        <GuestListPanel searchText={searchText} data={guestlistData.yes} heading={guestlistData.rsvp_style && guestlistData.rsvp_style.yes || "Yes"} panelType="yes" />
        { !window.is_premium &&
          <GuestListPanel searchText={searchText} data={guestlistData.maybe}
                                                heading={guestlistData.rsvp_style && guestlistData.rsvp_style.maybe || "Maybe"}
                                                panelType="maybe"/>
        }
        <GuestListPanel searchText={searchText} data={guestlistData.no} heading={guestlistData.rsvp_style && guestlistData.rsvp_style.no || "No"} panelType="no" />
        <GuestListPanel searchText={searchText} data={guestlistData.undecided} heading="Not Yet Replied" panelType="undecided" />
      </div>
    )
  }
});

const SearchBar = React.createClass({
  render() {
    const { searchText } = this.props;
    let iconClass = searchText.length > 0 ? 'search-icon has-value' : 'search-icon';
    return (
      <div className="search-bar">
        <input type="text" placeholder="Search" value={searchText} onChange={this.onChange} />
        <span className={iconClass} onClick={this.clearSearch}></span>
      </div>
    )
  },
  onChange(event) {
    actions.updateSearchText(event.target.value);
  },
  clearSearch() {
    actions.updateSearchText('');
  }
});

const GuestListPanel = React.createClass({
  getInitialState: function() {
    return {
      showAll: false,
      collapsed: false,
      totalAdults: 0,
      totalKids: 0,
      guestlistData: []
    }
  },
  componentDidMount: function() {
    this.setTotalsGuests(this.props);
  },
  componentWillReceiveProps: function (nextProps) {
    this.setTotalsGuests(nextProps);
  },
  setTotalsGuests(props) {
    const searchText = props.searchText;
    let theSearchText = accent_fold(searchText.trim().toLowerCase());
    const guestlistData = props.data.filter((item) => {
      return accent_fold(item.name.toLowerCase()).includes(theSearchText);
    });
    // Calculate Guest Count
    let totalAdults = 0;
    let totalKids = 0;
    for (let i = 0; i < guestlistData.length; i++) {
      if (guestlistData[i]) {
        totalAdults += guestlistData[i].adults_in_party;
        totalKids += guestlistData[i].kids_in_party;
      }
    }
    this.setState({
      totalAdults,
      totalKids,
      guestlistData
    });
  },
  render: function() {
    const guestlistData = this.state.guestlistData;
    const totalGuests = this.state.totalAdults + this.state.totalKids;
    const limit = this.state.showAll ? guestlistData.length : 24;
    const kidsAllowed = window.evite_event.options.event_option_allow_kids;
    const collapsedClass = this.state.collapsed ? "collapsed" : "";

    let guestListNodes = [];

    for (let i = 0; i < limit; i++) {
      if (guestlistData[i]) {
        guestListNodes.push(
          <GuestListItem panelType={this.props.panelType} data={guestlistData[i]} key={i} />
        )
      }
    }
    return (
      <div id={`guestlist-panel-${this.props.panelType}`} className={`guestlist-panel guestlist-panel-${guestlistData.length} ${collapsedClass}`}>
        <div className="guestlist-titleblock" onClick={this.handleHeadingClick}>
          <h4>
            {this.props.heading}
            <small> ({totalGuests})</small>
          </h4>
          { kidsAllowed && totalGuests > 0 &&
            <small className="total-counts">
              {this.state.totalAdults} Adults | {this.state.totalKids} Kids
            </small>
          }
        </div>
        <div className="guestlist-inner">
          { guestlistData.length > 0 &&
            <ul>
              {guestListNodes}
            </ul>
          }
          { guestlistData.length > limit &&
            <div className="show-more-wrap">
              <a href="#" onClick={this.handleShowMoreClick} className="button-primary-inverse small">Show all</a>
            </div>
          }
          { this.state.showAll &&
            <div className="show-more-wrap">
              <a href="#" onClick={this.handleShowLessClick} className="button-primary-inverse small">Show less</a>
            </div>
          }
        </div>
      </div>
    );
  },
  handleHeadingClick: function() {
    this.setState({
      collapsed: !this.state.collapsed
    })
  },
  handleShowMoreClick: function(e) {
    e.preventDefault();
    this.setState({
      showAll: true
    })
  },
  handleShowLessClick: function(e) {
    e.preventDefault();
    this.setState({
      showAll: false
    })
  }
});

function GuestListItem(props) {
  const data = props.data;
  return (
    <li>
      <GuestAvatar name={data.name} userId={data.user_id} />
      <div className="guest-details">
        <UserProfileLink
          userId={data.user_id}
          firstName={data.name}
        />
        { props.panelType !== 'undecided' &&
          <div className="guest-count">
            <small>
              {getGuestCountLabel(data.total_in_party, data.adults_in_party, data.kids_in_party)}
            </small>
          </div>
        }
        <ReplyStatus dateReplied={data.date_replied} dateViewed={data.date_viewed} />
      </div>
    </li>
  )
}

function GuestAvatar(props) {
  const { userId, name } = props;
  let badge = '';
  if (window.user_id == userId) {
    badge = 'You';
  } else if (window.evite_event.host_id == userId) {
    badge = 'Host';
  }
  return (
    <div className="avatar-container">
      <UserAvatar userId={userId} firstName={name} lastName='' />
      { badge &&
        <span className="host-you-badge">{badge}</span>
      }
    </div>
  )
}

function ReplyStatus(props) {
  const { dateReplied, dateViewed } = props;
  let status = '';
  if (dateReplied) {
    status = <small>Replied <TimeSince timestamp={dateReplied} /></small>;
  } else {
    if (utils.isHost()) {
      if (dateViewed) {
        status = <small>Viewed <TimeSince timestamp={dateViewed} /></small>;
      } else {
        status = <small>Not yet viewed</small>;
      }
    } else {
      status = <small>Not yet replied</small>;
    }
  }
  return (
    <div className="reply-status">
      {status}
    </div>
  )
}

function PrivateGuestList(props) {
  return (
    <div className="feed-notice">
      <p><b>The host of this event has chosen to hide the guest list.</b></p><br/>
      { props.showInviteMore &&
        <InviteMore
          inviteMoreUrl={window.invite_more_url}
          eventTitle={window.evite_event.title}
          eventShortlink={window.evite_event.shortlink}
          facebookSendUrl={window.facebook_send_url}
        />
      }
    </div>
  )
}

function InviteMore(props) {
  if (utils.isMobile()) {
    const smsBodyPrefix = window.is_ios_device ? '&' : '?';
    return (
      <div className="invite-more-container">
        <a href={props.inviteMoreUrl} className="invite_more button-primary small">Invite More</a>
        <a
          href={`sms: ${smsBodyPrefix}body=You're invited to ${props.eventTitle}: ${props.eventShortlink}`}
          className="invite_more button-primary-inverse small"
        >
          Share via Text
        </a>
      </div>
    )
  } else {
    return (
      <div className="invite-more-container">
        <a href={props.inviteMoreUrl} className="invite_more button-primary small">Invite More</a>
        <span className="or">or</span>
        <FacebookSendButton url={props.facebookSendUrl} />
      </div>
    )
  }
}

const FacebookSendButton = React.createClass({
  shouldComponentUpdate: function() {
    return false;
  },
  componentDidMount: function () {
    const facebookSendBtn = findDOMNode(this.refs.facebookSendBtn);
    if (window.FB) {
      window.FB.XFBML.parse(facebookSendBtn);
    }
  },
  render: function () {
    return (
      <div ref="facebookSendBtn" className="facebook-send-button">
        <div className="fb-send" data-href={this.props.url} data-size="small"></div>
      </div>
    )
  }
});

const TwitterShareButton = React.createClass({
   shouldComponentUpdate: function() {
    return false;
  },
  render: function() {
    return (
        <a className="button-twitter" href={`https://www.twitter.com/intent/tweet?text=&url=${ window.event.shortlink }&counturl=http://www.evite.com/event/${ window.event.id }&text=Check%20out%20my%20%40evite%20invitation:%20${ window.event.title }`}>Share on Twitter</a>
    )
  }
});

function getGuestCountLabel(totalCount, adultsCount, kidsCount) {
  const kidsAllowed = window.evite_event.options.event_option_allow_kids;
  const adultsKidsText = kidsCount > 0 ? `${common_utils.pluralize("Adult", adultsCount)}, ${common_utils.pluralize("Kid", kidsCount)}` : `${common_utils.pluralize("Adult", adultsCount)}`;
  return kidsAllowed ? adultsKidsText : common_utils.pluralize('Guest', totalCount);
};

function mapStateToProps(state) {
  return {
    state: {
      guestlist: state.guestlist
    }
  }
};

const connectedGuestList = connect(mapStateToProps)(GuestList);




//////////////////////////////////////////////////////////////////////////////
// bwherry for EVT-7148, setTotalsGuests() above needs to compare "accent
// folded" versions of guest names.
// TODO where to put this? Or is there some library function that does this?
// (see the accent_fold() function, below)
// Basically copied from here:
// https://github.com/aristus/accent-folding/blob/master/accent-fold.js

//accent-folding function
var accent_map = {
'ẚ':'a',
'Á':'a',
'á':'a',
'À':'a',
'à':'a',
'Ă':'a',
'ă':'a',
'Ắ':'a',
'ắ':'a',
'Ằ':'a',
'ằ':'a',
'Ẵ':'a',
'ẵ':'a',
'Ẳ':'a',
'ẳ':'a',
'Â':'a',
'â':'a',
'Ấ':'a',
'ấ':'a',
'Ầ':'a',
'ầ':'a',
'Ẫ':'a',
'ẫ':'a',
'Ẩ':'a',
'ẩ':'a',
'Ǎ':'a',
'ǎ':'a',
'Å':'a',
'å':'a',
'Ǻ':'a',
'ǻ':'a',
'Ä':'a',
'ä':'a',
'Ǟ':'a',
'ǟ':'a',
'Ã':'a',
'ã':'a',
'Ȧ':'a',
'ȧ':'a',
'Ǡ':'a',
'ǡ':'a',
'Ą':'a',
'ą':'a',
'Ā':'a',
'ā':'a',
'Ả':'a',
'ả':'a',
'Ȁ':'a',
'ȁ':'a',
'Ȃ':'a',
'ȃ':'a',
'Ạ':'a',
'ạ':'a',
'Ặ':'a',
'ặ':'a',
'Ậ':'a',
'ậ':'a',
'Ḁ':'a',
'ḁ':'a',
'Ⱥ':'a',
'ⱥ':'a',
'Ǽ':'a',
'ǽ':'a',
'Ǣ':'a',
'ǣ':'a',
'Ḃ':'b',
'ḃ':'b',
'Ḅ':'b',
'ḅ':'b',
'Ḇ':'b',
'ḇ':'b',
'Ƀ':'b',
'ƀ':'b',
'ᵬ':'b',
'Ɓ':'b',
'ɓ':'b',
'Ƃ':'b',
'ƃ':'b',
'Ć':'c',
'ć':'c',
'Ĉ':'c',
'ĉ':'c',
'Č':'c',
'č':'c',
'Ċ':'c',
'ċ':'c',
'Ç':'c',
'ç':'c',
'Ḉ':'c',
'ḉ':'c',
'Ȼ':'c',
'ȼ':'c',
'Ƈ':'c',
'ƈ':'c',
'ɕ':'c',
'Ď':'d',
'ď':'d',
'Ḋ':'d',
'ḋ':'d',
'Ḑ':'d',
'ḑ':'d',
'Ḍ':'d',
'ḍ':'d',
'Ḓ':'d',
'ḓ':'d',
'Ḏ':'d',
'ḏ':'d',
'Đ':'d',
'đ':'d',
'ᵭ':'d',
'Ɖ':'d',
'ɖ':'d',
'Ɗ':'d',
'ɗ':'d',
'Ƌ':'d',
'ƌ':'d',
'ȡ':'d',
'ð':'d',
'É':'e',
'Ə':'e',
'Ǝ':'e',
'ǝ':'e',
'é':'e',
'È':'e',
'è':'e',
'Ĕ':'e',
'ĕ':'e',
'Ê':'e',
'ê':'e',
'Ế':'e',
'ế':'e',
'Ề':'e',
'ề':'e',
'Ễ':'e',
'ễ':'e',
'Ể':'e',
'ể':'e',
'Ě':'e',
'ě':'e',
'Ë':'e',
'ë':'e',
'Ẽ':'e',
'ẽ':'e',
'Ė':'e',
'ė':'e',
'Ȩ':'e',
'ȩ':'e',
'Ḝ':'e',
'ḝ':'e',
'Ę':'e',
'ę':'e',
'Ē':'e',
'ē':'e',
'Ḗ':'e',
'ḗ':'e',
'Ḕ':'e',
'ḕ':'e',
'Ẻ':'e',
'ẻ':'e',
'Ȅ':'e',
'ȅ':'e',
'Ȇ':'e',
'ȇ':'e',
'Ẹ':'e',
'ẹ':'e',
'Ệ':'e',
'ệ':'e',
'Ḙ':'e',
'ḙ':'e',
'Ḛ':'e',
'ḛ':'e',
'Ɇ':'e',
'ɇ':'e',
'ɚ':'e',
'ɝ':'e',
'Ḟ':'f',
'ḟ':'f',
'ᵮ':'f',
'Ƒ':'f',
'ƒ':'f',
'Ǵ':'g',
'ǵ':'g',
'Ğ':'g',
'ğ':'g',
'Ĝ':'g',
'ĝ':'g',
'Ǧ':'g',
'ǧ':'g',
'Ġ':'g',
'ġ':'g',
'Ģ':'g',
'ģ':'g',
'Ḡ':'g',
'ḡ':'g',
'Ǥ':'g',
'ǥ':'g',
'Ɠ':'g',
'ɠ':'g',
'Ĥ':'h',
'ĥ':'h',
'Ȟ':'h',
'ȟ':'h',
'Ḧ':'h',
'ḧ':'h',
'Ḣ':'h',
'ḣ':'h',
'Ḩ':'h',
'ḩ':'h',
'Ḥ':'h',
'ḥ':'h',
'Ḫ':'h',
'ḫ':'h',
'H':'h',
'̱':'h',
'ẖ':'h',
'Ħ':'h',
'ħ':'h',
'Ⱨ':'h',
'ⱨ':'h',
'Í':'i',
'í':'i',
'Ì':'i',
'ì':'i',
'Ĭ':'i',
'ĭ':'i',
'Î':'i',
'î':'i',
'Ǐ':'i',
'ǐ':'i',
'Ï':'i',
'ï':'i',
'Ḯ':'i',
'ḯ':'i',
'Ĩ':'i',
'ĩ':'i',
'İ':'i',
'i':'i',
'Į':'i',
'į':'i',
'Ī':'i',
'ī':'i',
'Ỉ':'i',
'ỉ':'i',
'Ȉ':'i',
'ȉ':'i',
'Ȋ':'i',
'ȋ':'i',
'Ị':'i',
'ị':'i',
'Ḭ':'i',
'ḭ':'i',
'I':'i',
'ı':'i',
'Ɨ':'i',
'ɨ':'i',
'Ĵ':'j',
'ĵ':'j',
'J':'j',
'̌':'j',
'ǰ':'j',
'ȷ':'j',
'Ɉ':'j',
'ɉ':'j',
'ʝ':'j',
'ɟ':'j',
'ʄ':'j',
'Ḱ':'k',
'ḱ':'k',
'Ǩ':'k',
'ǩ':'k',
'Ķ':'k',
'ķ':'k',
'Ḳ':'k',
'ḳ':'k',
'Ḵ':'k',
'ḵ':'k',
'Ƙ':'k',
'ƙ':'k',
'Ⱪ':'k',
'ⱪ':'k',
'Ĺ':'a',
'ĺ':'l',
'Ľ':'l',
'ľ':'l',
'Ļ':'l',
'ļ':'l',
'Ḷ':'l',
'ḷ':'l',
'Ḹ':'l',
'ḹ':'l',
'Ḽ':'l',
'ḽ':'l',
'Ḻ':'l',
'ḻ':'l',
'Ł':'l',
'ł':'l',
'Ł':'l',
'̣':'l',
'ł':'l',
'̣':'l',
'Ŀ':'l',
'ŀ':'l',
'Ƚ':'l',
'ƚ':'l',
'Ⱡ':'l',
'ⱡ':'l',
'Ɫ':'l',
'ɫ':'l',
'ɬ':'l',
'ɭ':'l',
'ȴ':'l',
'Ḿ':'m',
'ḿ':'m',
'Ṁ':'m',
'ṁ':'m',
'Ṃ':'m',
'ṃ':'m',
'ɱ':'m',
'Ń':'n',
'ń':'n',
'Ǹ':'n',
'ǹ':'n',
'Ň':'n',
'ň':'n',
'Ñ':'n',
'ñ':'n',
'Ṅ':'n',
'ṅ':'n',
'Ņ':'n',
'ņ':'n',
'Ṇ':'n',
'ṇ':'n',
'Ṋ':'n',
'ṋ':'n',
'Ṉ':'n',
'ṉ':'n',
'Ɲ':'n',
'ɲ':'n',
'Ƞ':'n',
'ƞ':'n',
'ɳ':'n',
'ȵ':'n',
'N':'n',
'̈':'n',
'n':'n',
'̈':'n',
'Ó':'o',
'ó':'o',
'Ò':'o',
'ò':'o',
'Ŏ':'o',
'ŏ':'o',
'Ô':'o',
'ô':'o',
'Ố':'o',
'ố':'o',
'Ồ':'o',
'ồ':'o',
'Ỗ':'o',
'ỗ':'o',
'Ổ':'o',
'ổ':'o',
'Ǒ':'o',
'ǒ':'o',
'Ö':'o',
'ö':'o',
'Ȫ':'o',
'ȫ':'o',
'Ő':'o',
'ő':'o',
'Õ':'o',
'õ':'o',
'Ṍ':'o',
'ṍ':'o',
'Ṏ':'o',
'ṏ':'o',
'Ȭ':'o',
'ȭ':'o',
'Ȯ':'o',
'ȯ':'o',
'Ȱ':'o',
'ȱ':'o',
'Ø':'o',
'ø':'o',
'Ǿ':'o',
'ǿ':'o',
'Ǫ':'o',
'ǫ':'o',
'Ǭ':'o',
'ǭ':'o',
'Ō':'o',
'ō':'o',
'Ṓ':'o',
'ṓ':'o',
'Ṑ':'o',
'ṑ':'o',
'Ỏ':'o',
'ỏ':'o',
'Ȍ':'o',
'ȍ':'o',
'Ȏ':'o',
'ȏ':'o',
'Ơ':'o',
'ơ':'o',
'Ớ':'o',
'ớ':'o',
'Ờ':'o',
'ờ':'o',
'Ỡ':'o',
'ỡ':'o',
'Ở':'o',
'ở':'o',
'Ợ':'o',
'ợ':'o',
'Ọ':'o',
'ọ':'o',
'Ộ':'o',
'ộ':'o',
'Ɵ':'o',
'ɵ':'o',
'Ṕ':'p',
'ṕ':'p',
'Ṗ':'p',
'ṗ':'p',
'Ᵽ':'p',
'Ƥ':'p',
'ƥ':'p',
'P':'p',
'̃':'p',
'p':'p',
'̃':'p',
'ʠ':'q',
'Ɋ':'q',
'ɋ':'q',
'Ŕ':'r',
'ŕ':'r',
'Ř':'r',
'ř':'r',
'Ṙ':'r',
'ṙ':'r',
'Ŗ':'r',
'ŗ':'r',
'Ȑ':'r',
'ȑ':'r',
'Ȓ':'r',
'ȓ':'r',
'Ṛ':'r',
'ṛ':'r',
'Ṝ':'r',
'ṝ':'r',
'Ṟ':'r',
'ṟ':'r',
'Ɍ':'r',
'ɍ':'r',
'ᵲ':'r',
'ɼ':'r',
'Ɽ':'r',
'ɽ':'r',
'ɾ':'r',
'ᵳ':'r',
'ß':'s',
'Ś':'s',
'ś':'s',
'Ṥ':'s',
'ṥ':'s',
'Ŝ':'s',
'ŝ':'s',
'Š':'s',
'š':'s',
'Ṧ':'s',
'ṧ':'s',
'Ṡ':'s',
'ṡ':'s',
'ẛ':'s',
'Ş':'s',
'ş':'s',
'Ṣ':'s',
'ṣ':'s',
'Ṩ':'s',
'ṩ':'s',
'Ș':'s',
'ș':'s',
'ʂ':'s',
'S':'s',
'̩':'s',
's':'s',
'̩':'s',
'Þ':'t',
'þ':'t',
'Ť':'t',
'ť':'t',
'T':'t',
'̈':'t',
'ẗ':'t',
'Ṫ':'t',
'ṫ':'t',
'Ţ':'t',
'ţ':'t',
'Ṭ':'t',
'ṭ':'t',
'Ț':'t',
'ț':'t',
'Ṱ':'t',
'ṱ':'t',
'Ṯ':'t',
'ṯ':'t',
'Ŧ':'t',
'ŧ':'t',
'Ⱦ':'t',
'ⱦ':'t',
'ᵵ':'t',
'ƫ':'t',
'Ƭ':'t',
'ƭ':'t',
'Ʈ':'t',
'ʈ':'t',
'ȶ':'t',
'Ú':'u',
'ú':'u',
'Ù':'u',
'ù':'u',
'Ŭ':'u',
'ŭ':'u',
'Û':'u',
'û':'u',
'Ǔ':'u',
'ǔ':'u',
'Ů':'u',
'ů':'u',
'Ü':'u',
'ü':'u',
'Ǘ':'u',
'ǘ':'u',
'Ǜ':'u',
'ǜ':'u',
'Ǚ':'u',
'ǚ':'u',
'Ǖ':'u',
'ǖ':'u',
'Ű':'u',
'ű':'u',
'Ũ':'u',
'ũ':'u',
'Ṹ':'u',
'ṹ':'u',
'Ų':'u',
'ų':'u',
'Ū':'u',
'ū':'u',
'Ṻ':'u',
'ṻ':'u',
'Ủ':'u',
'ủ':'u',
'Ȕ':'u',
'ȕ':'u',
'Ȗ':'u',
'ȗ':'u',
'Ư':'u',
'ư':'u',
'Ứ':'u',
'ứ':'u',
'Ừ':'u',
'ừ':'u',
'Ữ':'u',
'ữ':'u',
'Ử':'u',
'ử':'u',
'Ự':'u',
'ự':'u',
'Ụ':'u',
'ụ':'u',
'Ṳ':'u',
'ṳ':'u',
'Ṷ':'u',
'ṷ':'u',
'Ṵ':'u',
'ṵ':'u',
'Ʉ':'u',
'ʉ':'u',
'Ṽ':'v',
'ṽ':'v',
'Ṿ':'v',
'ṿ':'v',
'Ʋ':'v',
'ʋ':'v',
'Ẃ':'w',
'ẃ':'w',
'Ẁ':'w',
'ẁ':'w',
'Ŵ':'w',
'ŵ':'w',
'W':'w',
'̊':'w',
'ẘ':'w',
'Ẅ':'w',
'ẅ':'w',
'Ẇ':'w',
'ẇ':'w',
'Ẉ':'w',
'ẉ':'w',
'Ẍ':'x',
'ẍ':'x',
'Ẋ':'x',
'ẋ':'x',
'Ý':'y',
'ý':'y',
'Ỳ':'y',
'ỳ':'y',
'Ŷ':'y',
'ŷ':'y',
'Y':'y',
'̊':'y',
'ẙ':'y',
'Ÿ':'y',
'ÿ':'y',
'Ỹ':'y',
'ỹ':'y',
'Ẏ':'y',
'ẏ':'y',
'Ȳ':'y',
'ȳ':'y',
'Ỷ':'y',
'ỷ':'y',
'Ỵ':'y',
'ỵ':'y',
'ʏ':'y',
'Ɏ':'y',
'ɏ':'y',
'Ƴ':'y',
'ƴ':'y',
'Ź':'z',
'ź':'z',
'Ẑ':'z',
'ẑ':'z',
'Ž':'z',
'ž':'z',
'Ż':'z',
'ż':'z',
'Ẓ':'z',
'ẓ':'z',
'Ẕ':'z',
'ẕ':'z',
'Ƶ':'z',
'ƶ':'z',
'Ȥ':'z',
'ȥ':'z',
'ʐ':'z',
'ʑ':'z',
'Ⱬ':'z',
'ⱬ':'z',
'Ǯ':'z',
'ǯ':'z',
'ƺ':'z',

//Roman fullwidth ascii equivalents: 0xff00 to 0xff5e
'２':'2',
'６':'6',
'Ｂ':'B',
'Ｆ':'F',
'Ｊ':'J',
'Ｎ':'N',
'Ｒ':'R',
'Ｖ':'V',
'Ｚ':'Z',
'ｂ':'b',
'ｆ':'f',
'ｊ':'j',
'ｎ':'n',
'ｒ':'r',
'ｖ':'v',
'ｚ':'z',
'１':'1',
'５':'5',
'９':'9',
'Ａ':'A',
'Ｅ':'E',
'Ｉ':'I',
'Ｍ':'M',
'Ｑ':'Q',
'Ｕ':'U',
'Ｙ':'Y',
'ａ':'a',
'ｅ':'e',
'ｉ':'i',
'ｍ':'m',
'ｑ':'q',
'ｕ':'u',
'ｙ':'y',
'０':'0',
'４':'4',
'８':'8',
'Ｄ':'D',
'Ｈ':'H',
'Ｌ':'L',
'Ｐ':'P',
'Ｔ':'T',
'Ｘ':'X',
'ｄ':'d',
'ｈ':'h',
'ｌ':'l',
'ｐ':'p',
'ｔ':'t',
'ｘ':'x',
'３':'3',
'７':'7',
'Ｃ':'C',
'Ｇ':'G',
'Ｋ':'K',
'Ｏ':'O',
'Ｓ':'S',
'Ｗ':'W',
'ｃ':'c',
'ｇ':'g',
'ｋ':'k',
'ｏ':'o',
'ｓ':'s',
'ｗ':'w'};

// Takes a string like "mesut özil" and returns "mesut ozil" - that is, the
// same string, but with "fancy accented characters" turned into their regular
// equivalents.
function accent_fold (s) {
  if (!s) {
    return s;
  }
  let outChars = [];
  for (let idx = 0; idx < s.length; idx++) {
    let theChar = s.charAt(idx)
    outChars.push(accent_map[theChar] || theChar);
  }
  return outChars.join('');
};
// TODO see note above
//////////////////////////////////////////////////////////////////////////////


export default connectedGuestList;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/guestlist/components.es6